import BaseService from './BaseService';
import AuthService from './AuthService';
import entities from 'src/config/entities';
import axios from "axios";
import { generateAvatar } from "src/plugins/avatarGenerator";

class UserService extends BaseService{

  constructor() {
    super({ entity: entities.USER });
  }

  async getProfile(params) {
    try {
      let res = await axios.get(`/you`);
      AuthService.setUserId(res.data.id);
      res.data.user.image = generateAvatar(res.data.user);
      return res;
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e, ...params});
      throw e;
    }
  }
  async changePassword(data) {
    try {
      let res = await axios.put(`/profile/password`, {
        password: data.currentPassword,
        password_new: data.newPassword,
        password_new_verify: data.newPasswordConfirm
      });
      return res;
    } catch (e) {
      this._handleError({ translationKey: 'generic.get.error', error: e});
      throw e;
    }
  }
}

export default new UserService();
